import _ from "utilities/vendor/lodash/4.17.21/js/lodash.custom.min";
import spartaSingletonUtility from "utilities/global/sparta-singleton-utility/1.0.0/js/sparta-singleton-utility";
import HttpClient from "utilities/community/http-client/1.2.1/js/client";
import HTTP from "utilities/community/http-client/1.2.1/js/client";
import Http from "utilities/community/http-client/1.2.1/js/client";
import $http from "utilities/community/http-client/1.2.1/js/client";












function hook(http) {
  http.$.csrfToken = null;

  let sp;
  try {
    sp = spaParams;
  } catch (e) {
    sp = {};
  }

  const tokenName = _.get(
    sp,
    `siteParams.CSRF_MIDDLEWARE_TOKENNAME`,
    'csrfToken'
  );
  const initUrl = _.get(sp, `siteParams.CSRF_MIDDLEWARE_INITIALURL`, null);

  const isEnabled = opt => {
    const options = opt.__options;
    return options.external === true ? false : (options.csrf ? options.csrf : true);
  };

  return {
    ajaxSend(xhr, opt) {
      const isPost = opt.type.toUpperCase() === 'POST';
      if (isEnabled(opt) && isPost && http.$.csrfToken) {
        xhr.setRequestHeader(tokenName, http.$.csrfToken);
      }
    },
    ajaxComplete(xhr, opt) {
      if (isEnabled(opt)) {
        const token = xhr.getResponseHeader(tokenName);
        if (token) {
          http.$.csrfToken = token;
        }
      }
    },
  };
}


Http.use(hook);
